import React from 'react';
import { SvgIconProps } from '@mui/material';

export const TasksListIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="29"
        height="30"
        viewBox="0 0 29 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_3268_5780)">
            <path
                d="M7.92662 6.39209H31.6637M7.92662 15.0744H31.6637M7.92662 23.7568H31.6637M1.45288 6.39209V6.41378M1.45288 15.0744V15.0961M1.45288 23.7568V23.7785"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_3268_5780">
                <rect
                    width="28.3519"
                    height="28.794"
                    fill="white"
                    transform="translate(0.0839844 0.78125)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default TasksListIcon;
